import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import ecommerceStoreModule from '@/views/apps/e-commerce/eCommerceStoreModule'
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import center from './center'
import whatsapp from './whatsapp'
import calendar from './calendar'
import print from './print'
import member_search from './member_search'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    print,
    calendar,
    appConfig,
    whatsapp,
    verticalMenu,
    member_search,
    center,

    'app-ecommerce': ecommerceStoreModule,
  },
  strict: process.env.DEV,
})
